import { Routine } from 'redux-saga-routines';
import {
  updateProfileRoutine,
  setUpdateProfileErrorRoutine
} from '../../routines';
import { ISaveUserError } from '../../../../common/models/user/ISaveUserError';

export type ProfileState = {
  isSaving: boolean;
  saveError: ISaveUserError | null;
};

const initialState: ProfileState = {
  isSaving: false,
  saveError: null
};

export const profile = (state: ProfileState = initialState, { type, payload }: Routine<any>): ProfileState => {
  switch (type) {
    case updateProfileRoutine.TRIGGER:
      return {
        ...state,
        isSaving: true
      };
    case updateProfileRoutine.SUCCESS:
      return {
        ...state,
        isSaving: false,
        saveError: null
      };
    case updateProfileRoutine.FAILURE:
      return {
        ...state,
        isSaving: false,
        saveError: payload
      };
    case setUpdateProfileErrorRoutine.TRIGGER:
      return {
        ...state,
        saveError: payload
      };
    default:
      return state;
  }
};
